import { filter } from "lodash";

// TOTO: Lưu dữ liệu khi user còn thao tác trên web thoát thì mất.
export const SessionStorageConfigKeys = {
  global: {},
  features: {
    /**
     * Sessoin storage luu cac key phuc vu module tuyen sinh cap dong phuc
     */
    tuyenSinhCapDongPhuc: {
      capPhatDongPhuc: {
        filters: 'features.tuyenSinhCapDongPhuc.capPhatDongPhuc.filters',
      },
      xuLyTrongNgay: {
        tongHopTrongNgay: {
          filters: 'features.tuyenSinhCapDongPhuc.xuLyTrongNgay.tongHopTrongNgay.filters',
        },
        doiTra: {
          filters: 'features.tuyenSinhCapDongPhuc.xuLyTrongNgay.doiTra.filters',
        }
      },
      thongKeBaoCao: {
        tong_hop: {
          filters: 'features.tuyenSinhCapDongPhuc.thongKeBaoCao.tong_hop.filters',
        },
        cap_phat: {
          filters: 'features.tuyenSinhCapDongPhuc.thongKeBaoCao.cap_phat.filters',
        },
        // B17 — mục 8: Xuất thống kê phiếu
        xuat_thong_ke: {
          filters: 'features.tuyenSinhCapDongPhuc.thongKeBaoCao.xuat_thong_ke.filters',
        }
      },
      sysSettingValue: {
        setting_vat_pham: 'features.tuyenSinhCapDongPhuc.sysSettingValue.setting_vat_pham',
        campus: 'features.tuyenSinhCapDongPhuc.sysSettingValue.campus',
      },
      thong_ke_ggsheet: {
        nhap_trong_ngay: 'features.tuyenSinhCapDongPhuc.thong_ke_ggsheet.nhap_trong_ngay'
      },
      dataBanDau: {
        filters: 'features.tuyenSinhCapDongPhuc.dataBanDau.filters',
      }
    },

    log: {
      filters: {
        filter: 'features.log.filters.filter',
      }
    }
  },
};
